import loginVisual from "../assets/imgs/landing-image.png";

const OutterLeftPanel = () => {
  return (
    <div className="w-7/12 h-full">
      <div className="h-full w-full overflow-hidden rounded-[12px] bg-white">
        <img
          src={loginVisual}
          alt="Login visual"
          className="h-full w-full"
          draggable={false}
        />
      </div>
    </div>
  );
};

export default OutterLeftPanel;
